/** @format */
const commonPrefix = "/v1/pl-report/";
const intranetService = `/v1/central-service/`;
export const REST_URLS = {
  LOGIN: `${commonPrefix}auth/login`,
  // REFRESH_TOKEN: `${commonPrefix}auth/refresh-tokens`,
  REFRESH_TOKEN: `${intranetService}auth/refresh-tokens-app`,
  LOGOUT: `${commonPrefix}auth/logout`,
  PL_ACTUAL: `${intranetService}pl-report/upload-pl-actual`,
  PL_AOP: `${intranetService}pl-report/upload-pl-AOP`,
  SALES_UPLOAD: `${intranetService}pl-report/sales-upload`,
  OPS_UPLOAD: `${intranetService}pl-report/ops-upload`,
  PL_UEM: `${intranetService}pl-report/upload-pl-uem`,
  DOWNLOAD_PL: `${intranetService}pl-report/download-pl-report`,
  PL_SUMMARY: `${intranetService}pl-report/summary`,
  QTD_SUMMARY: `${intranetService}pl-report/summary-quarterly`,
  EXPENSE_TREND: `${intranetService}pl-report/pl-expense-trends`,
  SALES_SUMMARY: `${intranetService}pl-report/sales-summary`,
  SALES_TREND: `${intranetService}pl-report/sales-trend`,
  PL_TREND: `${intranetService}pl-report/pl-trends`,
  EXPENSE_DASHBOARD: `${intranetService}pl-report/pl-expense-dashboard`,
  YTD_SUMMARY: `${intranetService}pl-report/summary-yearly`,
  AM_USERS: `${intranetService}users/user-list?additionalRole=Area Manager`,
  PL_FFILTERS: `${intranetService}pl-report/filters`,
  USER_LIST: `${intranetService}users/user-list`,
  MANAGER_LIST: `${intranetService}users/manager-user`,
  INPUT_FILE_SUMMARY: `${intranetService}pl-report/download-input-files`,
  OPS_SCORECARDS: `${intranetService}pl-report/ops-scorecard`,
  OPS_SCORECARDS_DOWNLOAD: `${intranetService}pl-report/ops-scorecard-download`,
  OPS_TRENDS: `${intranetService}pl-report/ops-trends`,
  OPS_TRENDS_DOWNLOAD: `${intranetService}pl-report/ops-trends-download`,
  SALES_INPUT_FILE_SUMMARY: `${intranetService}pl-report/download-files-sale`,
  SEND_EMAILS: `${intranetService}pl-report/send-email-summary`,
};

export const redirectToRoute = "/pl-report";
